import client from '@/config/directus.api';

const COLLECTION = 'w2p_templatecategories';

/**
 * Get templates
 */
export function getTemplateCategories() {
  return client
    .getItems(COLLECTION, {
      fields: ['*.*']
    })
    .then(response => {
      return response;
    })
    .catch(err => {
      return err;
    });
}

/**
 * Get template details by design id
 *
 * @param {int} id
 */
export function getTemplateCategory(id) {
  return client
    .getItems(COLLECTION, {
      fields: ['*.*.*'],
      filter: {
        id
      },
      single: true
    })
    .then(response => {
      return response;
    })
    .catch(err => {
      return err;
    });
}
